import { IconButton } from '@material-ui/core';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import React from 'react';
import { connect } from 'react-redux';
import { submit } from 'redux-form';
import { GREEN, RED, SUBSCRIPTION_TYPES } from '../../../_config/consts';
import * as ModalActions from '../../../redux/actions/modal.actions';
import * as UserActions from '../../../redux/actions/user.actions';
import * as UtilsActions from '../../../redux/actions/utils.actions';
import ArrowLeftIconCustom from '../../CustomIcons/ArrowLeftIconCustom.jsx';
import CheckOutlineIconCustom from '../../CustomIcons/CheckOutlineIconCustom.jsx';
import MDButton from '../../MDButton/MDButton.jsx';
import AndcardsLoginForm from '../../forms/Integrations/AndcardsLoginForm.jsx';
import AndcardsSelectOrganizationForm from '../../forms/Integrations/AndcardsSelectOrganizationForm.jsx';
import { localizeHelpCenterLink } from '../../../_config/utils.js';


@connect(state => ({ language: state.settings.language }))
class AndcardsSettingsOperationalSections extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = {
      isActive: null,
      organizations: null,
      activationData: {
        clientId: null,
        clientSecret: null,
      }
    };
  }

  async componentDidMount() {
    const { dispatch } = this.props;
    const isActive = dispatch(UserActions.userHasIntegrationActive(SUBSCRIPTION_TYPES.ANDCARDS_INTEGRATION));
    this.setState({ isActive });
  }

  async onAndcardsLogin(loginData) {
    const { dispatch } = this.props;
    dispatch(UtilsActions.setSpinnerVisibile(true));
    try {
      const organizations = await dispatch(UserActions.getAndcardsOrganizations(loginData.clientId, loginData.clientSecret));
      if (organizations) {
        dispatch(UtilsActions.setSpinnerVisibile(false));
        this.setState({ organizations, activationData: { clientId: loginData.clientId, clientSecret: loginData.clientSecret } });
      }
      dispatch(UtilsActions.setSpinnerVisibile(false));
    } catch (error) {
      let errorMessage = 'integrationConnectionError';
      if (error && error.message === 'ANDCARDS_ACTIVATION_FAILED_NO_BUSINESSES') {
        errorMessage = 'andcardsErrorNoBusiness';
      }
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_ALERT',
        modalProps: {
          anchorOrigin: { vertical: 'top', horizontal: 'center' },
          message: (<h6 className="snack-title"><Entity entity={errorMessage} /></h6>),
        },
      }));
    }
  }

  async onActivateAndcardsIntegration(selectedOrganizationId) {
    const { dispatch } = this.props;
    dispatch(UtilsActions.setSpinnerVisibile(true));
    try {
      const { activationData }  = this.state;
      await dispatch(UserActions.activateAndcardsIntegrationForOrganization(activationData.clientId, activationData.clientSecret, selectedOrganizationId));
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(UserActions.fetchCurrentActiveIntegrations());
      this.setState({ isActive: true });
      dispatch(ModalActions.showModal({
        modalType: 'SUCCESS_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="integrationConnectionSuccess" /></h6>),
        },
      }));
    } catch (error) {
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_ALERT',
        modalProps: {
          anchorOrigin: { vertical: 'top', horizontal: 'center' },
          message: (<h6 className="snack-title"><Entity entity="integrationConnectionError" /></h6>),
        },
      }));
    }
  }

  onDeactivateIntegrationRequest() {
    const { dispatch } = this.props;
    const params = {
      modalType: 'CONFIRM_TO_CONTINUE_MODAL',
      modalProps: {
        title: 'confirmBeforeContinue',
        body: <Entity entity="disableIntegrationConfirm" />,
        onConfirmText: <Entity entity="yes" />,
        onConfirm: () => this.onDeactivateIntegration(),
        onCancelText: <Entity entity="no" />,
        onCancel: () => dispatch(ModalActions.hideModal()),
      },
    };

    dispatch(ModalActions.showModal(params));
  }

  async onDeactivateIntegration() {
    const { dispatch } = this.props;
    dispatch(UtilsActions.setSpinnerVisibile(true));
    try {
      const andCardsDTO = dispatch(UserActions.getActiveIntegration(SUBSCRIPTION_TYPES.ANDCARDS_INTEGRATION));
      await dispatch(UserActions.disableIntegration(andCardsDTO.id));
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(UserActions.fetchCurrentActiveIntegrations());
      this.setState({ isActive: false });
      dispatch(ModalActions.showModal({
        modalType: 'SUCCESS_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="integrationDeactivatedSuccess" /></h6>),
        },
      }));
    } catch (error) {
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_ALERT',
        modalProps: {
          anchorOrigin: { vertical: 'top', horizontal: 'center' },
          message: (<h6 className="snack-title"><Entity entity="integrationDeactivatedError" /></h6>),
        },
      }));
    }

  }

  onGoBackToAndcardsLogin() {
    this.setState({ organizations: null, activationData: { clientId: null, clientSecret: null } });
  }

  onOpenActivationInfo() {
    const helpURL = localizeHelpCenterLink('activate-andcards-integration');
    window.open(helpURL);
  }

  render() {
    const { isActive, organizations } = this.state;
    const { dispatch } = this.props;
    return (
      <div style={{ paddingLeft: 20, paddingRight: 25, paddingTop: 50, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
        <img alt="nexudus" src="/imgs/common/integrationLogos/spacebring-logo-vertical-black.png" style={{ height: 100, alignSelf: 'center' }} />
        {isActive ? (
          <div style={{ marginTop: 20, display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
            <div style={{ width: '70%', margin: 'auto', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <CheckOutlineIconCustom style={{ color: GREEN, width: 30, marginRight: 10 }} />
              <h4 style={{ color: GREEN, fontWeight: 'bold', fontSize: 20 }}><Entity entity="integrationCorrectlyConfigured" /></h4>
            </div>
            <MDButton
              title={<Entity key={organizations} entity="disableIntegrationTitle" />}
              titleStyle={{ marginTop: 0, fontSize: 13 }}
              backgroundColor={RED}
              containerStyle={{ margin: 0, marginTop: 10, width: '80%' }}
              onClick={() => this.onDeactivateIntegrationRequest()}
            />
          </div>
        ) : (
          <div style={{ width: '70%', margin: 'auto' }}>
            <h4 style={{ color: '#3f3f3f', textAlign: 'center', marginTop: 10, marginBottom: 30 }}><Entity entity="connectYoutAccount" /></h4>
            {!organizations ? (
              <div>
                <div style={{ marginTop: 20 }}>
                  <AndcardsLoginForm
                    onSubmit={loginData => this.onAndcardsLogin(loginData)}
                  />
                </div>
                <MDButton
                  title={<Entity entity="login" key={organizations} />}
                  titleStyle={{ marginTop: 0, fontSize: 13 }}
                  backgroundColor="#000"
                  containerStyle={{ margin: 0, marginTop: 10, marginBottom: 10 }}
                  onClick={() => dispatch(submit('AndcardsLoginForm'))}
                />
              </div>
            ) : (
              <div>
                <div style={{ marginTop: 20 }}>
                  <AndcardsSelectOrganizationForm
                    organizations={organizations}
                    onSubmit={organizationData => this.onActivateAndcardsIntegration(organizationData.organizations)}
                  />
                </div>
                <MDButton
                  title={<Entity key={organizations} entity="connectYourAccount" />}
                  titleStyle={{ marginTop: 0, fontSize: 13 }}
                  backgroundColor="#000"
                  containerStyle={{ margin: 0, marginTop: 10 }}
                  onClick={() => dispatch(submit('AndcardsSelectOrganizationForm'))}
                />
                <IconButton onClick={() => this.onGoBackToAndcardsLogin()}>
                  <ArrowLeftIconCustom style={{ color: '#3f3f3f', width: 20, marginRight: 5 }} />
                </IconButton>
                <Entity style={{ color: '#3f3f3f', marginTop: 2 }} entity="backToLogin" />
              </div>
          )}
          </div>
        )}
        <h5
          className="link-label"
          style={{ margin: 'auto', width: 'fit-content', marginTop: 20, fontSize: 16, textDecoration: 'underline' }}
          onClick={() => this.onOpenActivationInfo()}
        >
          <Entity entity="findOutMore" />
        </h5>
      </div>
    );
  }
}

export default AndcardsSettingsOperationalSections;
